module.exports = __webpack_public_path__ + "img/footer.c0590881.png";